/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'no-app': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M17.481 2.42l.005.004a.621.621 0 01.004.875l-2.94 2.994.001 9.679c0 .703-.539 1.284-1.226 1.35l-.13.006h-6.33a1.358 1.358 0 01-1.35-1.226l-.006-.13v-.463l-2.061 2.102a.61.61 0 01-.862.008l-.004-.004a.621.621 0 01-.004-.875l2.93-2.988V4.216c0-.704.54-1.284 1.227-1.35l.13-.006h6.33c.704 0 1.284.539 1.35 1.226l.006.13v.32l2.068-2.107a.61.61 0 01.862-.009zm-3.834 12.195H6.413v1.357c0 .221.16.406.371.444l.081.008h6.33c.222 0 .407-.16.445-.371l.007-.082v-1.356zm-3.297.585a.452.452 0 11-.64.64.452.452 0 01.64-.64zm3.297-7.986L7.274 13.71h6.373V7.215zm-.452-3.45h-6.33a.453.453 0 00-.445.37l-.007.082v8.614l7.234-7.373V4.216a.452.452 0 00-.452-.452z" _fill="#000"/>'
  }
})
